import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.55 16.5 8 14q-1.65 0-2.825-1.175T4 10c0-1.65.392-2.042 1.175-2.825Q6.35 6 8 6c1.65 0 2.042.392 2.825 1.175Q12 8.35 12 10q0 .575-.137 1.063a3.7 3.7 0 0 1-.413.937l-3.175 5.5a.97.97 0 0 1-.85.5.93.93 0 0 1-.862-.5.96.96 0 0 1-.013-1m9 0L17 14q-1.65 0-2.825-1.175T13 10c0-1.65.392-2.042 1.175-2.825Q15.35 6 17 6c1.65 0 2.042.392 2.825 1.175Q21 8.35 21 10q0 .575-.137 1.063a3.7 3.7 0 0 1-.413.937l-3.175 5.5a.97.97 0 0 1-.85.5.93.93 0 0 1-.863-.5.96.96 0 0 1-.012-1" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }